module.exports = __webpack_public_path__ + "img/model-2.f0c08cb0.png";